// Error page internationalization - English
export default {
  // 404 Page
  404: {
    title: 'Page Not Found',
    message: 'Sorry, the page you visited does not exist or has been deleted.',
    goHome: 'Go Home',
    backPage: 'Go Back',
    suggestions: 'You might want to visit',
    suggestedLinks: {
      dashboard: 'Dashboard',
      orderManagement: 'Order Management',
      companyProfile: 'Company Profile',
      basicData: 'Basic Data'
    }
  },

  // 403 Page
  403: {
    title: 'Access Denied',
    message: 'Sorry, you do not have permission to access this page.',
    goHome: 'Go Home',
    backPage: 'Go Back',
    contactAdmin: 'Contact Administrator'
  },

  // 500 Page
  500: {
    title: 'Server Error',
    message: 'The server encountered an internal error, please try again later.',
    goHome: 'Go Home',
    backPage: 'Go Back',
    refresh: 'Refresh Page',
    reportProblem: 'Report Problem'
  },

  // Network Error
  network: {
    title: 'Network Connection Failed',
    message: 'Please check your network connection and try again.',
    retry: 'Reconnect',
    checkNetwork: 'Check Network'
  },

  // Common Errors
  common: {
    unknownError: 'Unknown Error',
    operationFailed: 'Operation Failed',
    pleaseTryAgain: 'Please try again later',
    http401: 'Login has expired, please log in again',
    http403: 'Insufficient permissions, access denied',
    http404: 'The requested resource does not exist',
    http5xx: 'Server error, please try again later'
  },
  price: {
    duplicate: 'An exact duplicate rate record already exists.'
  }
}